<template>
  <v-container>
    <location-item 
      v-for="(item, index) in $store.state.carts" 
      :key="index" 
      :item="item" 
      :index="index" />
  </v-container>
</template>
<script>
export default {
	mounted() {
		this.$nextTick(() => {
			this.$vuetify.goTo(0)
		})
	}
}
</script>
